// extracted by mini-css-extract-plugin
module.exports = {"preview-loader":"f_x","previewLoader":"f_x"};